/**
 * The CSS class used to toggle PrimeNG dark mode
 * @see https://primeng.org/theming
 */
export const PRIMENG_DARK_MODE_CSS_CLASS =
  'padspin-primeng-dark-mode-selector' as const;
